module.exports = __webpack_public_path__ + "img/20191011165925360截图20191011160925149.ad512d98.jpg";